import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const NotFound = () => {

  const navigate = useNavigate();

  useEffect(()=>{
    navigate("/main/dashboard")
  },[])

return(
  <Container>
    404
  </Container>
)

}
export default NotFound;

const Container = styled.div`

`;